<template lang="pug">
  #companion-topic-card
    RouterLink(:to="redirectTo")
      .flex-container
        .flex-item
          .cover-art-container(:style="{ backgroundColor: background }")
            img(:src="previewImage" :alt="'Not available'")
        .flex-item
          .custom-content
            .flex-item
              .title {{ title }}
            .flex-item.info-container
              WtSvgIcon(:icon="icon" width="20px" height="20px")
              span {{ totalGuides }} guides
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "GuideCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    redirectTo: { type: [Object, String], required: true },
    id: { type: String, default: "" },
    previewImage: { type: String, default: "" },
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
    totalGuides: { type: Number, default: 0 },
    background: { type: String, default: "a3d8ca" }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
#companion-topic-card {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #d9dbe0;
  justify-content: space-between;
  background: #fff;
  width: 100%;
  min-width: 222px !important;
  height: 218px;
}

.flex-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.cover-art-container {
  display: flex;
  min-width: 190px !important;
  height: 96px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.custom-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 74px !important;
}
.cover-art-container img {
  border-radius: 0.5rem !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.title {
  color: #1b1d20;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  max-width: 190px;
}

.info-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
}

.info-container span {
  color: #5a5c60;
  font-family: Manrope !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 18px !important;
}

@media (max-width: 767px) {
  #companion-topic-card {
    width: 100% !important;
    height: min-content !important;
  }
  .cover-art-container {
    width: 100% !important;
    height: auto !important;
  }

  .title {
    max-width: 100% !important;
  }
  .custom-content {
    gap: 16px !important;
    height: auto !important;
  }
}
</style>
